import FormattedMessage from 'I18n/components/FormattedMessage';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AssignmentPanelErrorState = () => /*#__PURE__*/_jsxs(ErrorMessage, {
  children: [/*#__PURE__*/_jsxs("p", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentPartitioning.assignmentPanelError.somethingsGoneWrong"
    }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentPartitioning.assignmentPanelError.refreshThePage"
    })]
  }), /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentPartitioning.assignmentPanelError.contactSupport"
    })
  })]
});
export default AssignmentPanelErrorState;